  (function () {
    var labelHost = document.getElementById('tvHeaderDrawer');
    var submenuBackLabel = labelHost ? labelHost.getAttribute('data-submenu-back') || '' : '';
    var submenuGoLabel = labelHost ? labelHost.getAttribute('data-submenu-go') || '' : '';

    function getDirectSubmenu(parent) {
      if (!parent || !parent.children) {
        return null;
      }

      for (var index = 0; index < parent.children.length; index += 1) {
        var child = parent.children[index];
        if (child.classList && child.classList.contains('subLinks')) {
          return child;
        }
      }

      return null;
    }

    function getDirectHasSubLink(parent) {
      if (!parent || !parent.children) {
        return null;
      }

      for (var index = 0; index < parent.children.length; index += 1) {
        var child = parent.children[index];
        if (child.tagName === 'A' && child.classList.contains('hasSub')) {
          return child;
        }
      }

      return null;
    }

    function getDirectLink(parent) {
      if (!parent || !parent.children) {
        return null;
      }

      for (var index = 0; index < parent.children.length; index += 1) {
        var child = parent.children[index];
        if (child.tagName === 'A') {
          return child;
        }
      }

      return null;
    }

    function normalizeHref(href) {
      if (!href) {
        return '';
      }

      var trimmedHref = href.trim();
      if (!trimmedHref || trimmedHref === '#') {
        return '';
      }

      var anchor = document.createElement('a');
      anchor.href = trimmedHref;
      return anchor.href;
    }

    function extractTriggerTitle(link) {
      if (!link) {
        return '';
      }

      var clone = link.cloneNode(true);
      Array.prototype.forEach.call(clone.querySelectorAll('.arw, .lbl, .icn, .prod-thumb'), function (node) {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
      return clone.textContent.replace(/\s+/g, ' ').trim();
    }

    function normalizeMenuKey(text) {
      if (!text) {
        return '';
      }

      var normalized = text.toLowerCase();

      if (typeof normalized.normalize === 'function') {
        normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }

      return normalized
        .replace(/[’'`]/g, '')
        .replace(/\+/g, ' plus ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function decoratePrimaryMenuIcons(tree) {
      if (!tree || tree.dataset.tvMenuIconsDecorated === 'true') {
        return;
      }

      tree.dataset.tvMenuIconsDecorated = 'true';

      var iconMap = {
        'home': 'home',
        'la novita': 'novita',
        'best seller': 'best-seller',
        'back in stock': 'back-stock',
        'langolo delle occasioni': 'occasion',
        'gusti dellasia': 'asia',
        'trovasia plus club': 'club',
        'trovasia club': 'club',
        'blog': 'blog'
      };

      Array.prototype.forEach.call(tree.children, function (item) {
        var link = getDirectLink(item);
        if (!link) {
          return;
        }

        var iconName = iconMap[normalizeMenuKey(extractTriggerTitle(link))];
        if (!iconName) {
          return;
        }

        link.classList.add('tv-header__menu-icon-link', 'tv-header__menu-icon--' + iconName);
      });
    }

    function formatSubmenuGoLabel() {
      return submenuGoLabel;
    }

    function findSubmenuBackItem(submenu) {
      if (!submenu || !submenu.children) {
        return null;
      }

      for (var index = 0; index < submenu.children.length; index += 1) {
        var child = submenu.children[index];
        if (child.classList && child.classList.contains('backto')) {
          return child;
        }
      }

      return null;
    }

    function setBackItemLabel(backItem, parentTitle) {
      if (!backItem) {
        return;
      }

      // The back row doubles as the submenu's title: arrow + the parent's name, "Torna" for screen readers.
      var arrow = backItem.querySelector('.arw');
      var arrowClone = arrow ? arrow.cloneNode(true) : null;
      var inlineGoLink = backItem.querySelector('.tv-header__submenu-go-link');
      var label = document.createElement('span');
      label.className = 'tv-header__submenu-back-label';
      label.textContent = parentTitle || submenuBackLabel;
      if (parentTitle) {
        backItem.setAttribute('aria-label', submenuBackLabel + ': ' + parentTitle);
      }
      backItem.textContent = '';

      if (arrowClone) {
        backItem.appendChild(arrowClone);
      }

      backItem.appendChild(label);

      if (inlineGoLink) {
        // re-runs keep the collection link that an earlier pass moved into this row
        backItem.appendChild(inlineGoLink);
      }
    }

    function findSubmenuGoItem(submenu, parentTrigger) {
      if (!submenu || !submenu.children) {
        return null;
      }

      var triggerHref = normalizeHref(parentTrigger ? parentTrigger.getAttribute('href') : '');
      if (!triggerHref) {
        return null;
      }

      for (var index = 0; index < submenu.children.length; index += 1) {
        var child = submenu.children[index];
        if (child.classList && child.classList.contains('backto')) {
          continue;
        }

        var directLink = getDirectLink(child);
        if (!directLink || directLink.classList.contains('hasSub')) {
          continue;
        }

        if (normalizeHref(directLink.getAttribute('href')) === triggerHref) {
          return child;
        }
      }

      return null;
    }

    function pruneProductSubmenuArtifacts(submenu) {
      if (!submenu) {
        return;
      }

      Array.prototype.slice.call(submenu.children).forEach(function (child) {
        if (child.classList && child.classList.contains('lvl-2') && child.parentNode) {
          child.parentNode.removeChild(child);
        }
      });

      Array.prototype.forEach.call(submenu.querySelectorAll('[data-deferred-menu] template.deferred-menu__template'), function (template) {
        if (template.content) {
          Array.prototype.slice.call(template.content.querySelectorAll('li.lvl-2')).forEach(function (node) {
            if (node.parentNode) {
              node.parentNode.removeChild(node);
            }
          });
          return;
        }

        var wrapper = document.createElement('div');
        wrapper.innerHTML = template.innerHTML;
        Array.prototype.slice.call(wrapper.querySelectorAll('li.lvl-2')).forEach(function (node) {
          if (node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
        template.innerHTML = wrapper.innerHTML;
      });
    }

    function removeDuplicateGoItems(submenu, parentTrigger, keepItem) {
      if (!submenu || !submenu.children) {
        return;
      }

      var triggerHref = normalizeHref(parentTrigger ? parentTrigger.getAttribute('href') : '');
      if (!triggerHref) {
        return;
      }

      Array.prototype.slice.call(submenu.children).forEach(function (child) {
        if (child === keepItem || (child.classList && child.classList.contains('backto'))) {
          return;
        }

        var directLink = getDirectLink(child);
        if (!directLink || directLink.classList.contains('hasSub')) {
          return;
        }

        if (normalizeHref(directLink.getAttribute('href')) === triggerHref) {
          child.parentNode.removeChild(child);
        }
      });
    }

    function normalizeSubmenuCopy(tree) {
      if (!tree) {
        return;
      }

      Array.prototype.forEach.call(tree.querySelectorAll('.subLinks'), function (submenu) {
        var parentListItem = submenu.parentElement;
        var parentTrigger = getDirectHasSubLink(parentListItem);
        pruneProductSubmenuArtifacts(submenu);

        var backItem = findSubmenuBackItem(submenu);
        var goItem = findSubmenuGoItem(submenu, parentTrigger);

        if (backItem) {
          setBackItemLabel(backItem, parentTrigger ? extractTriggerTitle(parentTrigger) : '');
        }

        if (goItem) {
          var goLink = getDirectLink(goItem);
          if (goLink) {
            goItem.classList.add('tv-header__submenu-go-item');
            goLink.classList.add('tv-header__submenu-go-link');
            goLink.textContent = formatSubmenuGoLabel();
            if (backItem) {
              // shares the sticky back row: "‹ Category" on the left, the collection link on the right
              goLink.classList.add('tv-header__submenu-go-link--inline');
              backItem.appendChild(goLink);
              goItem.parentNode.removeChild(goItem);
              removeDuplicateGoItems(submenu, parentTrigger, backItem);
            } else {
              submenu.appendChild(goItem);
              removeDuplicateGoItems(submenu, parentTrigger, goItem);
            }
          }
        }
      });
    }

    function syncTreeSubmenuLayer(tree) {
      if (!tree) {
        return;
      }

      tree.classList.toggle('has-open-submenu', !!tree.querySelector('.subLinks.is-active'));
    }

    function hasDirectSupportItem(tree) {
      if (!tree || !tree.children) {
        return false;
      }

      for (var index = 0; index < tree.children.length; index += 1) {
        var child = tree.children[index];
        if (child.classList && child.classList.contains('tv-header__support-item')) {
          return true;
        }
      }

      return false;
    }

    function createSupportItemFromTemplate(template) {
      if (!template) {
        return null;
      }

      if (template.content && template.content.firstElementChild) {
        return template.content.firstElementChild.cloneNode(true);
      }

      var wrapper = document.createElement('div');
      wrapper.innerHTML = template.innerHTML.trim();
      return wrapper.firstElementChild ? wrapper.firstElementChild.cloneNode(true) : null;
    }

    function mountSupportIntoTree(tree, template) {
      if (!tree || !template || hasDirectSupportItem(tree)) {
        return;
      }

      var supportItem = createSupportItemFromTemplate(template);
      if (supportItem) {
        tree.appendChild(supportItem);
      }
    }

    function getFocusable(container) {
      if (!container) {
        return [];
      }

      return Array.prototype.slice.call(
        container.querySelectorAll('a[href], button:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return !element.hasAttribute('hidden');
      });
    }

    function getOverlayLockCount(bodyEl) {
      if (!bodyEl) {
        return 0;
      }

      var count = parseInt(bodyEl.dataset.tvOverlayLockCount || '0', 10);
      return isFinite(count) && count > 0 ? count : 0;
    }

    function getScrollbarWidth() {
      return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    }

    function saveOverlayLockSnapshot(htmlEl, bodyEl, scrollY) {
      bodyEl.dataset.tvOverlayScrollY = String(scrollY);
      bodyEl.dataset.tvOverlayBodyOverflow = bodyEl.style.overflow || '';
      bodyEl.dataset.tvOverlayBodyPaddingRight = bodyEl.style.paddingRight || '';
      bodyEl.dataset.tvOverlayBodyPosition = bodyEl.style.position || '';
      bodyEl.dataset.tvOverlayBodyTop = bodyEl.style.top || '';
      bodyEl.dataset.tvOverlayBodyLeft = bodyEl.style.left || '';
      bodyEl.dataset.tvOverlayBodyRight = bodyEl.style.right || '';
      bodyEl.dataset.tvOverlayBodyWidth = bodyEl.style.width || '';
      bodyEl.dataset.tvOverlayHtmlOverflow = htmlEl.style.overflow || '';
      bodyEl.dataset.tvOverlayHtmlScrollBehavior = htmlEl.style.scrollBehavior || '';
    }

    function clearOverlayLockSnapshot(bodyEl) {
      delete bodyEl.dataset.tvOverlayLockCount;
      delete bodyEl.dataset.tvOverlayScrollY;
      delete bodyEl.dataset.tvOverlayBodyOverflow;
      delete bodyEl.dataset.tvOverlayBodyPaddingRight;
      delete bodyEl.dataset.tvOverlayBodyPosition;
      delete bodyEl.dataset.tvOverlayBodyTop;
      delete bodyEl.dataset.tvOverlayBodyLeft;
      delete bodyEl.dataset.tvOverlayBodyRight;
      delete bodyEl.dataset.tvOverlayBodyWidth;
      delete bodyEl.dataset.tvOverlayHtmlOverflow;
      delete bodyEl.dataset.tvOverlayHtmlScrollBehavior;
    }

    function lockScroll() {
      var htmlEl = document.documentElement;
      var bodyEl = document.body;
      if (!htmlEl || !bodyEl || bodyEl.dataset.tvHeaderLocked === 'true') {
        return;
      }

      var currentLockCount = getOverlayLockCount(bodyEl);

      if (currentLockCount === 0) {
        var scrollY = window.pageYOffset || htmlEl.scrollTop || 0;
        saveOverlayLockSnapshot(htmlEl, bodyEl, scrollY);

        var scrollbarWidth = getScrollbarWidth();
        if (scrollbarWidth > 0) {
          bodyEl.style.paddingRight = scrollbarWidth + 'px';
        }

        bodyEl.style.position = 'fixed';
        bodyEl.style.top = '-' + scrollY + 'px';
        bodyEl.style.left = '0';
        bodyEl.style.right = '0';
        bodyEl.style.width = '100%';
        bodyEl.style.overflow = 'hidden';
        htmlEl.style.overflow = 'hidden';
      }

      bodyEl.dataset.tvHeaderLocked = 'true';
      bodyEl.dataset.tvOverlayLockCount = String(currentLockCount + 1);
      htmlEl.classList.add('tv-header-nav-open');
    }

    function unlockScroll() {
      var htmlEl = document.documentElement;
      var bodyEl = document.body;
      if (!htmlEl || !bodyEl || bodyEl.dataset.tvHeaderLocked !== 'true') {
        return;
      }

      delete bodyEl.dataset.tvHeaderLocked;

      var currentLockCount = getOverlayLockCount(bodyEl);
      var nextLockCount = Math.max(0, currentLockCount - 1);

      if (nextLockCount > 0) {
        bodyEl.dataset.tvOverlayLockCount = String(nextLockCount);
        htmlEl.classList.remove('tv-header-nav-open');
        return;
      }

      var scrollY = parseInt(bodyEl.dataset.tvOverlayScrollY || '0', 10);
      var originalScrollBehavior = bodyEl.dataset.tvOverlayHtmlScrollBehavior || '';
      htmlEl.style.scrollBehavior = 'auto';
      bodyEl.style.overflow = bodyEl.dataset.tvOverlayBodyOverflow || '';
      bodyEl.style.paddingRight = bodyEl.dataset.tvOverlayBodyPaddingRight || '';
      bodyEl.style.position = bodyEl.dataset.tvOverlayBodyPosition || '';
      bodyEl.style.top = bodyEl.dataset.tvOverlayBodyTop || '';
      bodyEl.style.left = bodyEl.dataset.tvOverlayBodyLeft || '';
      bodyEl.style.right = bodyEl.dataset.tvOverlayBodyRight || '';
      bodyEl.style.width = bodyEl.dataset.tvOverlayBodyWidth || '';
      htmlEl.style.overflow = bodyEl.dataset.tvOverlayHtmlOverflow || '';
      htmlEl.classList.remove('tv-header-nav-open');

      void bodyEl.offsetHeight;
      window.scrollTo(0, isFinite(scrollY) ? scrollY : 0);
      htmlEl.style.scrollBehavior = originalScrollBehavior;
      clearOverlayLockSnapshot(bodyEl);
    }

    function resetPane(panel) {
      if (!panel) {
        return;
      }

      Array.prototype.forEach.call(panel.querySelectorAll('.subLinks.is-active'), function (submenu) {
        submenu.classList.remove('is-active');
      });

      Array.prototype.forEach.call(panel.querySelectorAll('.hasSub.is-current'), function (link) {
        link.classList.remove('is-current');
      });

      var tree = panel.querySelector('.tv-header__mobile-tree');
      if (tree) {
        tree.scrollTop = 0;
        syncTreeSubmenuLayer(tree);
      }
    }

    function setActivePane(host, paneName, options) {
      var shouldReset = !options || options.reset !== false;

      Array.prototype.forEach.call(host.querySelectorAll('[data-tv-pane]'), function (button) {
        var isActive = button.getAttribute('data-tv-pane') === paneName;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      Array.prototype.forEach.call(host.querySelectorAll('[data-tv-pane-panel]'), function (panel) {
        var isActive = panel.getAttribute('data-tv-pane-panel') === paneName;
        panel.classList.toggle('is-active', isActive);
        if (isActive && shouldReset) {
          resetPane(panel);
        }
      });
    }

    function triggerChat(button) {
      // Shopify Inbox web component (storefront/web-components/chat.js): public show() API.
      var shopifyChat = document.querySelector('shopify-chat');
      if (shopifyChat && window.customElements) {
        if (typeof shopifyChat.show === 'function') {
          shopifyChat.show();
          return;
        }
        var upgraded = false;
        window.customElements.whenDefined('shopify-chat').then(function () {
          upgraded = true;
          shopifyChat.show();
        });
        window.setTimeout(function () {
          if (!upgraded && button.getAttribute('data-tv-chat-href')) {
            window.location.href = button.getAttribute('data-tv-chat-href');
          }
        }, 3000);
        return;
      }

      var chatRoot = document.getElementById('shopify-chat');
      var chatElement = chatRoot ? chatRoot.querySelector('inbox-online-store-chat') : null;

      if (chatElement) {
        var shadow = chatElement.shadowRoot;
        var toggleButton = shadow ? shadow.querySelector('button[data-spec="toggle-button"]') : null;
        if (toggleButton) {
          toggleButton.click();
          return;
        }
      }

      var fallbackUrl = button.getAttribute('data-tv-chat-href');
      if (fallbackUrl) {
        window.location.href = fallbackUrl;
      }
    }

    function triggerMail(button) {
      var mailto = button.getAttribute('data-tv-mailto');
      if (mailto) {
        window.location.href = mailto;
      }
    }

    function focusWithoutScroll(element) {
      if (!element || typeof element.focus !== 'function') {
        return;
      }

      try {
        element.focus({ preventScroll: true });
      } catch (error) {
        element.focus();
      }
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-tv-header-root]'), function (root) {
      if (root.dataset.tvHeaderBound === 'true') {
        return;
      }

      root.dataset.tvHeaderBound = 'true';

      var drawer = document.querySelector('[data-tv-header-drawer]');
      var supportTemplate = document.querySelector('[data-tv-support-template]');
      var toggle = root.querySelector('[data-tv-header-toggle]');
      var closeTimer = null;
      var openTimer = null;
      var contentReadyTimer = null;
      var lastFocused = null;
      var drawerTransitionMs = 240;

      if (!drawer || !toggle) {
        return;
      }

      decoratePrimaryMenuIcons(drawer.querySelector('#tvHeaderMenuTree'));

      Array.prototype.forEach.call(drawer.querySelectorAll('.tv-header__mobile-tree'), function (tree) {
        mountSupportIntoTree(tree, supportTemplate);
        normalizeSubmenuCopy(tree);
      });

      function openDrawer(paneName) {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
        if (openTimer) {
          window.cancelAnimationFrame(openTimer);
          openTimer = null;
        }
        if (contentReadyTimer) {
          window.cancelAnimationFrame(contentReadyTimer);
          contentReadyTimer = null;
        }

        lastFocused = document.activeElement;
        drawer.classList.remove('is-content-ready');
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        setActivePane(drawer, paneName || 'menu');

        openTimer = window.requestAnimationFrame(function () {
          openTimer = null;
          drawer.classList.add('is-open');
          contentReadyTimer = window.requestAnimationFrame(function () {
            contentReadyTimer = null;
            if (!drawer.classList.contains('is-open')) {
              return;
            }
            drawer.classList.add('is-content-ready');
            lockScroll();
            var focusTarget = drawer.querySelector('.tv-header__drawer-close');
            if (focusTarget) {
              focusWithoutScroll(focusTarget);
            }
          });
        });
      }

      function closeDrawer(options) {
        var shouldRestoreFocus = !options || options.restoreFocus !== false;

        if (openTimer) {
          window.cancelAnimationFrame(openTimer);
          openTimer = null;
        }
        if (contentReadyTimer) {
          window.cancelAnimationFrame(contentReadyTimer);
          contentReadyTimer = null;
        }
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');

        closeTimer = window.setTimeout(function () {
          drawer.hidden = true;
          drawer.classList.remove('is-content-ready');
          unlockScroll();
          if (shouldRestoreFocus && lastFocused && typeof lastFocused.focus === 'function') {
            focusWithoutScroll(lastFocused);
          }
        }, drawerTransitionMs);
      }

      root.__tvHeaderApi = {
        open: openDrawer,
        close: closeDrawer
      };

      window.__tvFreshHeaderOpenMenu = function (paneName) {
        openDrawer(paneName || 'menu');
      };

      toggle.addEventListener('click', function () {
        openDrawer('menu');
      });

      drawer.addEventListener('click', function (event) {
        var closeButton = event.target.closest('[data-tv-header-close]');
        if (closeButton) {
          event.preventDefault();
          closeDrawer();
          return;
        }

        var tabButton = event.target.closest('[data-tv-pane]');
        if (tabButton) {
          event.preventDefault();
          setActivePane(drawer, tabButton.getAttribute('data-tv-pane'));
          return;
        }

        var submenuLink = event.target.closest('.tv-header__mobile-tree a.hasSub');
        if (submenuLink) {
          var submenu = getDirectSubmenu(submenuLink.parentElement);
          if (submenu) {
            var parentList = submenu.parentElement ? submenu.parentElement.parentElement : null;
            var treeRoot = submenuLink.closest('.tv-header__mobile-tree');
            event.preventDefault();
            normalizeSubmenuCopy(treeRoot);
            if (parentList) {
              submenu.dataset.tvParentScrollTop = String(parentList.scrollTop || 0);
              parentList.scrollTop = 0;
            }
            submenuLink.classList.add('is-current');
            submenu.classList.add('is-active');
            submenu.scrollTop = 0;
            syncTreeSubmenuLayer(treeRoot);
          }
          return;
        }

        if (event.target.closest('.tv-header__mobile-tree .backto .tv-header__submenu-go-link')) {
          return;
        }

        var backLink = event.target.closest('.tv-header__mobile-tree .backto');
        if (backLink && backLink.parentElement.classList.contains('subLinks')) {
          event.preventDefault();
          var currentPanel = backLink.parentElement;
          var parentList = currentPanel.parentElement ? currentPanel.parentElement.parentElement : null;
          var previousScrollTop = parseInt(currentPanel.dataset.tvParentScrollTop || '0', 10);
          currentPanel.classList.remove('is-active');
          currentPanel.scrollTop = 0;
          if (parentList) {
            parentList.scrollTop = isFinite(previousScrollTop) ? previousScrollTop : 0;
          }
          var parentListItem = currentPanel.parentElement;
          var parentTrigger = getDirectHasSubLink(parentListItem);
          if (parentTrigger) {
            parentTrigger.classList.remove('is-current');
            focusWithoutScroll(parentTrigger);
          }
          syncTreeSubmenuLayer(currentPanel.closest('.tv-header__mobile-tree'));
          return;
        }

        var chatButton = event.target.closest('[data-tv-chat-trigger]');
        if (chatButton) {
          event.preventDefault();
          closeDrawer({ restoreFocus: false });
          window.setTimeout(function () {
            triggerChat(chatButton);
          }, 60);
          return;
        }

        var mailButton = event.target.closest('[data-tv-mail-trigger]');
        if (mailButton) {
          event.preventDefault();
          closeDrawer({ restoreFocus: false });
          window.setTimeout(function () {
            triggerMail(mailButton);
          }, 60);
          return;
        }

        var plainLink = event.target.closest('.tv-header__mobile-tree a');
        if (plainLink && !plainLink.classList.contains('hasSub')) {
          closeDrawer({ restoreFocus: false });
        }
      });

      drawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer();
          return;
        }

        if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) {
          return;
        }

        var focusables = getFocusable(drawer.querySelector('.tv-header__drawer-panel'));
        if (!focusables.length) {
          return;
        }

        var first = focusables[0];
        var last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          focusWithoutScroll(last);
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          focusWithoutScroll(first);
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 1025 && drawer.classList.contains('is-open')) {
          closeDrawer({ restoreFocus: false });
        }
      });
    });

    if (!window.__tvFreshHeaderMenuBridgeBound) {
      window.__tvFreshHeaderMenuBridgeBound = true;
      document.addEventListener('click', function (event) {
        var toolbarTrigger = event.target.closest('.mbtMenu');
        if (!toolbarTrigger || typeof window.__tvFreshHeaderOpenMenu !== 'function') {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        window.__tvFreshHeaderOpenMenu('menu');
      }, true);
    }
  })();
